import { useLocation, useNavigate, useParams } from "react-router-dom";

import Loader from "@/components/loader";
import { apiUserGetCompanies } from "@/api";
import { useData } from "@/utility/state/contextAPI";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function GoogleOAuthCallbackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const {
    auth: { contextSetJwtToken },
  } = useData();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
        const providerName = params.providerName;
        const queryString = location.search;

        if (!queryString) {
          console.error("No query parameters received from OAuth");
          navigate("/login?error=oauth_failed");
          return;
        }

        console.log(
          `Processing ${providerName} OAuth callback with params:`,
          queryString
        );

        const callbackUrl = `${apiBaseUrl}auth/${providerName}/callback${queryString}`;
        console.log("Calling Strapi callback URL:", callbackUrl);

        const response = await fetch(callbackUrl, {
          method: "GET",
          headers: {
            Accept: "application/json, text/plain, */*",
            "User-Agent": "Mozilla/5.0 (compatible; OAuth-Client)",
          },
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error(
            `Couldn't login to Strapi. Status: ${response.status}`,
            errorText
          );
          navigate("/login?error=oauth_failed");
          return;
        }

        const contentType = response.headers.get("content-type");

        const responseText = await response.text();

        let result;
        try {
          result = JSON.parse(responseText);
          console.log("Parsed JSON result:", result);
        } catch (parseError) {
          console.error("Failed to parse JSON:", parseError);
          console.error("Response was:", responseText);
          navigate("/login?error=oauth_failed");
          return;
        }

        if (!result.jwt) {
          console.error("No JWT token received from Strapi:", result);
          navigate("/login?error=oauth_failed");
          return;
        }

        console.log("Successfully logged with Strapi");

        localStorage.setItem("jwtToken", result.jwt);
        if (result.user?.username) {
          localStorage.setItem("username", result.user.username);
        }

        contextSetJwtToken(result.jwt);

        const companyResponse = await apiUserGetCompanies(result.jwt);

        if (companyResponse?.status >= 400 || !companyResponse?.data) {
          console.error("Failed to get companies:", companyResponse);
          navigate("/login?error=oauth_failed");
          return;
        }

        const { data: companyList } = companyResponse;

        if (companyList && companyList.length > 0) {
          navigate(`/companyListPage`);
        } else {
          navigate(`/addCompanyListPage`);
        }
      } catch (error) {
        console.error("Error with OAuth callback:", error);
        navigate("/login?error=oauth_failed");
      }
    };

    handleCallback();
  }, [navigate, contextSetJwtToken, params.providerName, location.search]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <Loader isLoading={true} />
        <p className="mt-4 text-gray-600">
          {t("login.processingLogin") || "處理登入中..."}
        </p>
      </div>
    </div>
  );
}

export default GoogleOAuthCallbackPage;
